module.exports = __webpack_public_path__ + "img/logo_branco.83a5b63a.png";